import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import {P2, ValueTitle} from '../Kit/Kit';
import Close from "react-icons/lib/md/close"


const ContentContainer = styled.div`
  display: flex;
  position: relative;
`;

const ValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 75%;
  background: #fff;
  position: relative;
  padding: 50px 0;
  
  @media (min-width: 768px) {
   width: 100%;
   max-width: 800px;
  }
  
  h1 {
    margin: 20px 0;
  }
  
  svg {
    position: absolute;
    top: 1%;
    right: 1%;
    cursor: pointer;
    font-size: 30px;
    color: #909090
  }
`;

const ValueImg = styled.img`
  width: 135px;
  height: 135px;
`;

const ValueText = P2.extend`
  padding: 0 20px;
  @media(min-width: 768px){
    padding: 0 100px;
  }
`;

class ValuesModal extends React.Component {
    render() {
        const {isOpen, close, modalData: {title, description, image}} = this.props;
        return (
          <Modal
            ariaHideApp={false}
            isOpen={isOpen}
            onRequestClose={() => close()}
            style={{
                overlay: {
                    position: `fixed`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: `rgba(0, 0, 0, 0.75)`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                content: {
                    position: `relative`,
                    border: `none`,
                    background: `none`,
                    padding: 0,
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    overflow: `auto`,
                    WebkitOverflowScrolling: `touch`,
                },
            }}
            contentLabel="Modal"
          >
              <ContentContainer>
                  <ValuesContainer>
                      <ValueImg
                        src={image.source_url}
                        alt={image.alt_text}
                      />
                      <ValueTitle>{title}</ValueTitle>
                      <ValueText
                        dangerouslySetInnerHTML={{__html: description}}
                      />
                      <Close
                        onClick={() => close()}
                      />
                  </ValuesContainer>
              </ContentContainer>
          </Modal>
        );
    }
}

export default ValuesModal;


// WEBPACK FOOTER //
// ./src/components/Modals/ValuesModal.js